import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_CUSTOMER_FAILURE,
  FETCH_CUSTOMER_REQUEST,
  FETCH_CUSTOMER_SUCCESS,
  CustomerActionType,
  SET_START_END_DATE,
} from '../types/customerType';
import { Customer } from 'src/types/model';

export const fetchCustomerRequest = (): CustomerActionType => ({
  type: FETCH_CUSTOMER_REQUEST,
});

export const fetchCustomerSuccess = (data: Customer[]): CustomerActionType => ({
  type: FETCH_CUSTOMER_SUCCESS,
  payload: data,
});

export const fetchCustomerFailure = (error: string): CustomerActionType => ({
  type: FETCH_CUSTOMER_FAILURE,
  payload: error,
});

export const fetchCustomer = () => {
  return async (dispatch: Dispatch<CustomerActionType>) => {
    dispatch(fetchCustomerRequest());
    try {
      const request = await Service.get('/users/own');
      const data: Customer[] = request?.data?.data;
      dispatch(fetchCustomerSuccess(data));
    } catch (error: any) {
      dispatch(fetchCustomerFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch customer');
    }
  };
};

export const setCustomerDate = (data: any): CustomerActionType => ({
  type: SET_START_END_DATE,
  payload: data,
});
